import { useMyOrg } from '../../layouts/AppStateContextLayout/utils'
import { formatCityState } from '../../utils'
import Text, { TextSize } from '../Typography/Text'

const CityFooterDisplay = () => {
  const org = useMyOrg()
  const city = org?.city ?? ''
  const state = org?.state
  const displayName = org?.displayName

  if (!displayName && !city && !state) {
    return null
  }

  return (
    <Text
      size={TextSize.Large}
      className="block px-2 py-1.5 !text-neutral-950 dark:!text-neutral-50"
    >
      {displayName || formatCityState(city, state)}
    </Text>
  )
}

export default React.memo(CityFooterDisplay)
